import * as React from 'react';
import { TStockCreateBody, TStockType } from 'api/stock/stock.types';

export type TStockFormValues = Omit<TStockCreateBody, 'variation'> & {
  variation: string;
};

type TStockFormProps = {
  onSubmit: (data: TStockFormValues) => void;
  isLoading?: boolean;
};

export type TStockForm = React.FC<TStockFormProps>;

export const STOCK_TYPE_OPTIONS: Array<{ id: TStockType; label: string }> = [
  { id: 'phoneCase', label: 'Phone case' },
];
